module.exports = __webpack_public_path__ + "img/icon-test-reports.e1ff752c.svg";